/* eslint-disable no-undefined */
import { AdyenGateway } from '../utils/adyen/AdyenGateway'
import Payment from 'payment'
import { isEmptyObject } from '../utils/helpers/helpers'

export const adyenValidaCartao = cartaoCredito => {
  const adyen = new AdyenGateway()
  return adyen.checkout( cartaoCredito )
    .catch( result => {
      throw result.errors.reduce( ( acc, curr ) => ( {
        ...acc,
        [ curr.source === 'dt_validade' ? 'validade' : curr.source ]: curr.message
      } ), {} )
    } )
    .then( result => {
      if ( !isEmptyObject( result ) ) {
        return {
          'ano_validade': result.exp_year + 2000,
          'bandeira': Payment.fns.cardType( cartaoCredito.numero ) || undefined,
          'mes_validade': result.exp_month,
          'nome': result.holder_name,
          'token': result.id,
          'ultimos_digitos': result.last_four_digits
        }
      }
    } )
}
